<div class="bcg p-4">
  <div class="row my-3">
    <div class="col-lg-7 col-sm-7 col-md-7">
      <p class="nav_link_cat ms-1 mb-3 flex_row">
        <span class="clickable" (click)="gotoDashboard()">Dashboard</span>
        <span [style.font-weight]="'bold'"> >> </span>
        <span class="clickable" (click)="gotoListing()">Account Management</span>
        <span [style.font-weight]="'bold'"> >> </span>
        <span *ngIf="!editMode">Add New Account</span>
        <span *ngIf="editMode">Edit Account</span>
      </p>
    </div>
  </div>

  <div class="card card_outLine mt-3">
    <div class="card-body">
      <div class="row">
        <div *ngIf="editMode" class="col-lg-6 col-sm-6 col-md-6">
          <h5 class="title_five">Edit Account</h5>
          <p class="card-text text_p">Edit your account here!</p>
        </div>
        <div *ngIf="!editMode" class="col-lg-6 col-sm-6 col-md-6">
          <h5 class="title_five">Add New Account</h5>
          <p class="card-text text_p">Create new account here!</p>
        </div>
      </div>
    </div>
  </div>
  <div class="card card_outLine mt-3">
    <div class="card-body">
      <div class="row">
        <div *ngIf="!editMode" class="row mt-2 form_inputFields">
          <div class="col-11 m-2">
            <h5 class="title_five">Account Details</h5>
            <form [formGroup]="addAccountForm">
              <div formArrayName="addnewAccountDetails">
                <section
                  *ngFor="
                    let details of accountDetailsArray().controls;
                    let i = index
                  "
                  [formGroupName]="i"
                >
                  <div class="form_outline_sty">
                    <div class="row">
                      <div class="col-lg-4 col-sm-4 col-md-4">
                        <span class="form_field">Account Name</span
                        ><span class="color_red">*</span>
                        <input
                          class="form-control edit_input"
                          formControlName="name"
                          placeholder="Enter Name"
                          pInputText
                          type="text"
                          (paste)="handlePasteEvent($event)"
                          onkeypress="return (event.charCode >= 65 && event.charCode <= 90)
                          || (event.charCode >= 97 && event.charCode <= 122)
                          || (event.charCode >= 48 && event.charCode <= 57)
                          || event.charCode == 32"
                        />
                        <span
                          class="p-error"
                          style="font-size: 0.5rem"
                          *ngIf="
                            submitted &&
                            accountDetailsArray()
                              .at(i)
                              .get('name')
                              ?.hasError('required')
                          "
                          >*Maximum of 100 characters
                        </span>
                        <span class="p-error" style="font-size: 0.5rem" *ngIf="
                            accountDetailsArray()
                              .at(i)
                              .get('name')
                              ?.hasError('xssDetected')
                          ">*Malicious content detected! Please remove script tags.
                        </span>
                      </div>
                      <div class="col-lg-4 col-sm-4 col-md-4">
                        <span class="form_field">Contact</span
                        ><span class="color_red">*</span>
                        <input
                          class="form-control edit_input"
                          formControlName="contact"
                          placeholder="Enter contact"
                          pInputText
                          type="text"
                          (keypress)="numberOnlyForContact($event)"
                          maxlength="10"
                          minlength="10"
                        />
                        <span
                          class="p-error"
                          style="font-size: 0.5rem"
                          *ngIf="
                            submitted &&
                            accountDetailsArray()
                              .at(i)
                              .get('contact')
                              ?.hasError('required')
                          "
                          >*Enter a contact no.
                        </span>
                        <span
                          class="p-error"
                          style="font-size: 0.5rem"
                          *ngIf="
                            accountDetailsArray()
                              .at(i)
                              .get('contact')
                              ?.hasError('pattern')
                          "
                          >*Please enter a valid contact no. (10 digits starting
                          with 6, 7, 8, or 9)
                        </span>
                      </div>
                      <!-- <div class="col-lg-4 col-sm-4 col-md-4">
                                    <span class="form_field">Account Type</span><span
                                      class="color_red">*</span>
                                    <input class="form-control edit_input" formControlName="type" placeholder="Enter Type"
                                      pInputText type="text">
                                    <span class="p-error" style="font-size: 0.5rem;"
                                      *ngIf="submitted && accountDetailsArray().at(i).get('type')?.hasError('required')">*Maximum
                                      of 100 characters </span>
                                  </div> -->
                      <div
                        style="padding-top: 15px"
                        class="col-lg-1 col-sm-1 col-md-1 remove_btn"
                      >
                        <button
                          pButton
                          pRipple
                          type="button"
                          icon="pi pi-trash"
                          (click)="removeAccount(i)"
                          class="p-button-sm-outline"
                        ></button>
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col-lg-4 col-sm-4 col-md-4">
                        <span class="form_field">Organization Name</span
                        ><span class="color_red">*</span>
                        <input
                          class="form-control edit_input"
                          formControlName="organizationName"
                          placeholder="Enter Name"
                          pInputText
                          type="text"
                          [value]="organisation.name"
                          [readOnly]="true"
                        />
                        <span
                          class="p-error"
                          style="font-size: 0.5rem"
                          *ngIf="
                            submitted &&
                            accountDetailsArray()
                              .at(i)
                              .get('organizationName')
                              ?.hasError('required')
                          "
                          >*Maximum of 100 characters
                        </span>
                      </div>
                      <!-- <div class="col-lg-4 col-sm-4 col-md-4">
                                      <span class="form_field">No of Branch</span><span
                                        class="color_red">*</span>
                                      <input class="form-control edit_input" formControlName="branches" placeholder="Enter Type"
                                        pInputText type="text" (keypress)="numberOnly($event)">
                                      <span class="p-error" style="font-size: 0.5rem;"
                                        *ngIf="submitted && accountDetailsArray().at(i).get('branches')?.hasError('required')">*Enter a value </span>
                                    </div>
                                  -->
                    </div>
                  </div>
                </section>
              </div>

              <div class="custom_button me-2 mt-3" style="margin-left: 7px">
                <p-button
                  icon="pi pi-plus"
                  label="Add Account"
                  (click)="addNewAccountDetails()"
                  styleClass="p-button-sm-outline"
                ></p-button>
              </div>
            </form>
          </div>
          <div class="row"></div>
          <div
            class="text-right custom_button me-2 mt-3"
            style="margin-left: 7px"
          >
            <p-button
              label="Back"
              [routerLink]="['/doqfy/management/account-listing']"
              styleClass="p-button-sm"
              [style]="{ width: '5rem' }"
            ></p-button>
            <p-button
              class="ms-2"
              label="Save"
              [style]="{ width: '5rem' }"
              (click)="saveAccount()"
              styleClass="p-button-sm-outline"
            ></p-button>
          </div>
        </div>
        <div *ngIf="editMode" class="row mt-2 form_inputFields">
          <div class="col-12 px-3">
            <h5 class="title_five">Account Details</h5>
            <form [formGroup]="editAccountForm">
              <div>
                <div class="form_outline_sty">
                  <div class="row g-3">
                    <div class="col-lg-4 col-sm-4 col-md-4">
                      <span class="form_field">Account Name</span
                      ><span class="color_red">*</span>
                      <input
                        class="form-control edit_input"
                        formControlName="name"
                        placeholder="Enter Name"
                        pInputText
                        type="text"
                      />
                      <span
                        class="p-error"
                        style="font-size: 0.5rem"
                        *ngIf="
                          submitted &&
                          editAccountForm.get('name')?.hasError('required')
                        "
                        >*Maximum of 100 characters
                      </span>
                      <span class="p-error" style="font-size: 0.5rem" *ngIf="editAccountForm.get('name')?.hasError('xssDetected')">*Malicious
                        content detected! Please remove script tags.
                      </span>
                    </div>

                    <div class="col-lg-4 col-sm-4 col-md-4">
                      <span class="form_field">Contact</span
                      ><span class="color_red">*</span>
                      <input
                        class="form-control edit_input"
                        formControlName="contact"
                        placeholder="Enter contact"
                        pInputText
                        type="text"
                        (keypress)="numberOnly($event)"
                        maxlength="10"
                        minlength="10"
                      />
                      <span
                        class="p-error"
                        style="font-size: 0.5rem"
                        *ngIf="
                          submitted &&
                          editAccountForm.get('contact')?.hasError('required')
                        "
                        >*Enter a contact no.
                      </span>
                      <span
                        class="p-error"
                        style="font-size: 0.5rem"
                        *ngIf="
                          editAccountForm
                            .get('contact')
                            ?.hasError('maxlength') ||
                          editAccountForm.get('contact')?.hasError('minlength')
                        "
                        >*Please enter a valid contact no.
                      </span>
                    </div>

                    <div class="col-lg-4 col-sm-4 col-md-4">
                      <span class="form_field">Organization Name</span
                      ><span class="color_red">*</span>
                      <input
                        class="form-control edit_input grey_background"
                        formControlName="organizationName"
                        placeholder="Enter Name"
                        pInputText
                        type="text"
                        [readOnly]="true"
                        disabled="true"
                      />
                      <span
                        class="p-error"
                        style="font-size: 0.5rem"
                        *ngIf="
                          submitted &&
                          editAccountForm
                            .get('organizationName')
                            ?.hasError('required')
                        "
                        >*Maximum of 100 characters
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="text-right custom_button px-3 mt-3">
            <p-button
              label="Back"
              [style]="{ width: '5rem' }"
              [routerLink]="['/doqfy/management/account-listing']"
              styleClass="p-button-sm"
            ></p-button>
            <p-button
              class="ms-2"
              [style]="{ width: '5rem' }"
              label="Save"
              (click)="editAccount()"
              styleClass="p-button-sm-outline"
            ></p-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="toast_display_layer">
  <p-toast></p-toast>
</div>
